import { AnalyticsEvent } from "@/types/analytics";
import posthog from "posthog-js";

export const trackEvent = <Key extends keyof AnalyticsEvent>(key: Key, data?: AnalyticsEvent[Key]) => {
  posthog.capture(key, data);
};
